import { render, staticRenderFns } from "./ReadOnlyField.vue?vue&type=template&id=57b31ab0&"
import script from "./ReadOnlyField.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports